import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { Link, useHistory, useParams } from "react-router-dom";
import pendingBanner from "../../../../../../assets/images/pendingBannerAudio.png";
import demo from "../../../../../../assets/images/pendingIcons/demo.png";
import finish from "../../../../../../assets/images/pendingIcons/finish.png";
import jury from "../../../../../../assets/images/pendingIcons/jury.png";
import star from "../../../../../../assets/images/pendingIcons/star.png";
import start from "../../../../../../assets/images/pendingIcons/start.png";
import "./InstructionSendFeedback.css";
import "./PromoInstructionSendInfo.css";
import axios from "axios";
import { Markup } from "interweave";
import noImage from "../../../../../../assets/images/settings/no-image.png";
import Status2 from "../../../../../AuditionAdmin/AuditonRounds/AuditionStarStatus/StatusCom/Status2";
import icon2 from "../../../../../../assets/images/Rounds/icons/finish 1.png";
import icon3 from "../../../../../../assets/images/Rounds/icons/flag 1.png";
import moment from "moment";
import { Accordion } from "react-bootstrap";
import MakePostContent from "../../../../../AuditionAdmin/MakePostContent/MakePostContent";
import swal from "sweetalert";
import cup from "../../../../../../assets/images/page 1.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { serverInfo } from "../../../../../../App";
import { useContext } from "react";

const InstructionSendFeedback = (props) => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const slug = props.match.params.slug;
  const [checkData, setCheckData] = React.useState(0);
  const [audition, setAudition] = React.useState({});
  const [runningInstructionInfo, setRunningInstructionInfo] = React.useState(
    {}
  );
  const [promoInstructionSendInfos, setPromoInstructionSendInfos] =
    React.useState([]);

  const [file, setFile] = useState("");
  const [imageData, setImageData] = useState("");
  const [fileVideo, setFileVideo] = useState("");
  const [filePdf, setFilePdf] = useState("");
  const [videoFile, setVideoFile] = useState("");
  const [convertedContent, setConvertedContent] = useState(null);
  const [errorList, setErrorList] = useState([]);
  const history = useHistory();

  const checkDataHandler = (data) => {
    setCheckData(data.id);
    setRunningInstructionInfo(data);
  };

  const handleImageChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setImageData(file[0]);
  };
  const handleVideoChange = (file) => {
    setFileVideo(file[0]);
    setVideoFile(URL.createObjectURL(file[0]));
  };

  const handlePdfChange = (file) => {
    setFilePdf(file[0]);
  };

  const updatePromoInstructionInfo = (e) => {
    e.preventDefault();
    const fData = new FormData();
    fData.append("audition_id", audition.id);
    fData.append(
      "audition_promo_instruction_id",
      audition?.promo_instruction?.id
    );
    fData.append("instruction", convertedContent);
    fData.append("video", fileVideo);
    fData.append("image", imageData);
    fData.append("pdf", filePdf);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/audition-admin/audition/promo-instruction/update`, fData)
        .then((res) => {
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            getSingleAuditionInstructionInfo();
          } else {
            setErrorList(res.data.validation_errors);
          }
        });
    });
  };

  const getSingleAuditionInstructionInfo = () => {
    axios.get(`/api/audition-admin/audition-event/for-promo-instruction/${slug}`).then((res) => {
      if (res.data.status === 200) {
        setAudition(res.data.event);
        setPromoInstructionSendInfos(res.data?.promo_instruction_infos);
        setRunningInstructionInfo(res.data?.promo_instruction_infos[0]);
        setCheckData(res.data?.promo_instruction_infos[0]?.id);
        setConvertedContent(res.data.event.promo_instruction?.instruction);
        setVideoFile(videoCdnUrl + res.data.event.promo_instruction?.video);
        setFile(imageCdnUrl + res.data.event.promo_instruction?.image);
      }
    });
  };

  useEffect(() => {
    getSingleAuditionInstructionInfo();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-6 mb-2">
          <div className="card card-bg p-3 mb-3">
            <img
              src={
                runningInstructionInfo?.image
                  ? imageCdnUrl + runningInstructionInfo?.image
                  : noImage
              }
              alt=""
              className="img-fluid card-img-details"
            />
          </div>
        </div>
        <div className="col-md-6 mb-2">
          <div className="card card-bg p-3 mb-3">
            <ReactPlayer
              url={
                runningInstructionInfo?.video
                  ? videoCdnUrl + runningInstructionInfo?.video
                  : null
              }
              playing={true}
              controls={true}
              volume={1}
              width="100%"
              maxHeight="400px" // style={{ margin: "0 auto" }}
            />
          </div>
        </div>
      </div>

      <div className="col-md-12 mb-3">
        <div className="card card-bg shadow">
          <div className="card-body">
            <h5 className="text-light ">{audition && audition.title}</h5>

            <p className="text-light ">
              <Markup content={runningInstructionInfo?.instruction} />
            </p>

            <h5 className="text-warning">Instruction</h5>
            <div className="under-line"></div>
            <p className="text-light mt-2">
              <Markup content={runningInstructionInfo?.instruction} />
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default InstructionSendFeedback;
